import type { SVGProps } from 'react';

const SvgChevronArrowLeftBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M16 20L8 12L16 4' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgChevronArrowLeftBd;
